import { SvgIcon, SvgIconProps } from '@mui/material';

export function FullscreenIcon(props: SvgIconProps): React.JSX.Element {
  return (
    <SvgIcon viewBox="0 0 42 42" {...props}>
      <path
        clipRule="evenodd"
        d="M23.5 14.3333C23.0397 14.3333 22.6666 13.9602 22.6666 13.5C22.6666 13.0397 23.0397 12.6666 23.5 12.6666H28.5C28.9602 12.6666 29.3333 13.0397 29.3333 13.5V18.5C29.3333 18.9602 28.9602 19.3333 28.5 19.3333C28.0397 19.3333 27.6666 18.9602 27.6666 18.5V15.5118L23.2559 19.9225C22.9304 20.248 22.4028 20.248 22.0774 19.9225C21.7519 19.5971 21.7519 19.0695 22.0774 18.744L26.4881 14.3333H23.5ZM18.744 22.0774C19.0695 21.7519 19.5971 21.7519 19.9225 22.0774C20.248 22.4028 20.248 22.9304 19.9225 23.2559L15.5118 27.6666H18.5C18.9602 27.6666 19.3333 28.0397 19.3333 28.5C19.3333 28.9602 18.9602 29.3333 18.5 29.3333H13.5C13.0397 29.3333 12.6666 28.9602 12.6666 28.5V23.5C12.6666 23.0397 13.0397 22.6666 13.5 22.6666C13.9602 22.6666 14.3333 23.0397 14.3333 23.5V26.4881L18.744 22.0774Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
}
